import React from 'react';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { LANDING_TONE, LandingReveal, landingCaptionSx } from './LandingMotion';

const LandingHero = () => {
  const { loginWithRedirect } = useAuth();

  const handleSignup = () => {
    loginWithRedirect({
      authorizationParams: {
        screen_hint: 'signup',
        prompt: 'consent',
        scope: 'openid profile email offline_access',
        audience: process.env.REACT_APP_AUDIENCE,
      },
    });
  };

  return (
    <Box
      component="section"
      sx={{
        bgcolor: 'background.default',
        pt: { xs: 4, md: 8 },
        pb: { xs: 6, md: 10 },
      }}
    >
      <Container maxWidth="lg">
        <LandingReveal>
          <Box
            sx={{
              maxWidth: 640,
              pt: { md: 1 },
              pl: 2,
              borderLeft: `3px solid ${LANDING_TONE.ready.accent}`,
            }}
          >
          <Typography variant="caption" sx={landingCaptionSx}>
            From knowledge to action
          </Typography>
          <Typography
            component="h1"
            sx={{
              mt: 1.5,
              mb: 2.5,
              fontWeight: 600,
              letterSpacing: '-0.03em',
              lineHeight: 1.15,
                fontSize: { xs: '1.85rem', sm: '2.5rem', md: '3rem' },
              color: 'text.primary',
            }}
          >
            Practice decisions that matter
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              mb: 3.5,
              maxWidth: 560,
              fontSize: { xs: '1.05rem', sm: '1.15rem' },
              lineHeight: 1.65,
            }}
          >
            From leadership development and team alignment to onboarding and assessment, 
            Itclarifies helps organizations build skills and align teams. 
            People make decisions in realistic scenarios, explore trade-offs, receive feedback, and learn.
            
          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.5}
          >
            <Button variant="contained" size="large" onClick={handleSignup}>
              Start Free Trial
            </Button>
          </Stack>
          </Box>
        </LandingReveal>
      </Container>
    </Box>
  );
};

export default LandingHero;
